import { render, staticRenderFns } from "./MenuToggler.vue?vue&type=template&id=2a4d5e8c&scoped=true&"
import script from "./MenuToggler.vue?vue&type=script&lang=js&"
export * from "./MenuToggler.vue?vue&type=script&lang=js&"
import style0 from "./MenuToggler.vue?vue&type=style&index=0&id=2a4d5e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d5e8c",
  null
  
)

export default component.exports